module.exports = __webpack_public_path__ + "img/close.870b3079.png";